import React from 'react';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import { useSelector } from 'react-redux';

/**
 * Bottom menus after separator in side bar
 */

function BottomMenuList(props) {
    const { t, openDrawerStatus, lang } = props;
    const appSettings = useSelector((state) => state.appSettings);
    let domain = '';
    if (lang && appSettings && appSettings.languages) {
        appSettings.languages.forEach((langData) => {
            if (langData.code === lang) {
                domain = '//' + langData.domain;
            }
        });
    }
    //go to another domain.
    // function anotherDomain(url){
    //     window.location.href = 'https://' + url;
    // }
    //go to another page.
    function gotoPage(location, inNewTab = true) {
        if (inNewTab) {
            window.open(
                location,
                '_blank'
            );
        } else {
            window.location = location;
        }
    }

    return (
        <React.Fragment>
            {/* <Tooltip placement="right-end" title= {openDrawerStatus ? '' : 'Saved Articles'} aria-label = "Saved Articles" className="bottom-link">
                <ListItem button onClick={gotoPage.bind(this, domain +'/' +'saved-articles')}>
                    <i className="fa fa-file-text" aria-hidden="true" />
                    <ListItemText primary={t('saved_articles')} />
                </ListItem>
            </Tooltip>*/}
            <Tooltip placement="right-end" title={openDrawerStatus ? '' : 'Blog'} aria-label="Blog"
                     className="bottom-link">
                <ListItem button onClick={gotoPage.bind(this, domain + '/' + 'recents')}>
                    <i className="fa fa-align-left m-r-16" aria-hidden="true"/>
                    <ListItemText primary={t('blog')}/>
                </ListItem>
            </Tooltip>
        </React.Fragment>
    );
}

export default BottomMenuList;
